import React, { useEffect, useState } from 'react';
import { getInformationPages, moveUpInformationPage, moveDownInformationPage } from '../../api/information-page-api';
import Overlay from '../overlays/editInfoPage';
import { useLanguage } from '../../providers/preferenceProvider';
import { useConfig } from '../../providers/configProvider';
import { useToast } from '../../providers/toastProvider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare, faArrowUp, faArrowDown, faPlus } from '@fortawesome/free-solid-svg-icons'
import { ACL } from '../../acls';

const InformationPages = () => {
  const { isAuthorized } = useConfig();
  const { showLoading, hideLoading } = useToast();
  const [pages, setPages] = useState([]);
  const [showOverlay, setShowOverlay] = useState(false);
  const [overlayPage, setOverlayPage] = useState(null);
  const [createNew, setCreateNew] = useState(false);
  const { t } = useLanguage();

  const refreshPages = async () => {
    const response = await getInformationPages();
    if (response && response.data) {
      const sortedPages = [...response.data].sort((a, b) => a.orderIndex - b.orderIndex);
      setPages(sortedPages);
    }
  };

  useEffect(() => {
    setPages([]);
    refreshPages();
  }, []);

  function closeOverlay() {
    setShowOverlay(false);
    setOverlayPage(null);
  }

  const handleEditInformationPage = (page) => {
    setCreateNew(false);
    setOverlayPage(page);
    setShowOverlay(true);
  };

  const handleAddInformationPage = (page) => {
    setCreateNew(true);
    setShowOverlay(true);
  };

  const handleMoveUp = (page) => {
    if (!isAuthorized(ACL.INFORMATION_PAGE)) return;
    showLoading();
    moveUpInformationPage(page.id)
      .then(() => {
        setPages((prevPages) => {
          const newPages = [...prevPages];
          const index = newPages.findIndex((p) => p.id === page.id);
          if (index > 0) {
            [newPages[index], newPages[index - 1]] = [newPages[index - 1], newPages[index]];
          }
          return newPages;
        });
        hideLoading();
      })
      .catch((error) => {
        console.error('Error moving up information page:', error);
        hideLoading();
      });
  };

  const handleMoveDown = (page) => {
    if (!isAuthorized(ACL.INFORMATION_PAGE)) return;
    showLoading();
    moveDownInformationPage(page.id)
      .then(() => {
        setPages((prevPages) => {
          const newPages = [...prevPages];
          const index = newPages.findIndex((p) => p.id === page.id);
          if (index < newPages.length - 1) {
            [newPages[index], newPages[index + 1]] = [newPages[index + 1], newPages[index]];
          }
          return newPages;
        });
        hideLoading();
      })
      .catch((error) => {
        console.error('Error moving down information page:', error);
        hideLoading();
      });
  };

  return (
    <>
      <div className="admin-list-wrapper">
        <div className="admin-list-header mb-4 flex justify-between items-center">
          <div>{t.amount_of + " " + t.pages + ": " + pages.length}</div>
          <div>
            <button 
              className="admin-add-button"
              disabled={!isAuthorized(ACL.INFORMATION_PAGE)}
              onClick={handleAddInformationPage}
            >
              {t.add + " " + t.page} <FontAwesomeIcon icon={faPlus} />
            </button>
          </div>
        </div>
        <div className="admin-list-box">
        
          <div className="admin-list-header grid-cols-3 px-4 py-2">
            <div>{t.page}</div>
            <div>{t.order}</div>
          </div>

          {pages && pages.map((page, index) => (
            <div
              key={index}
              className="grid md:grid-cols-3 items-center px-3 py-2 rounded-md m-2 bg-[--white-color]"
            >
              <div className="flex items-center gap-3 ml-1">
                <span className="font-medium">{page.title}</span>
              </div>
              <div className="font-medium">
                <button 
                  className={isAuthorized(ACL.INFORMATION_PAGE) ? "admin-order-move" : "admin-order-move-disabled"}
                  onClick={() => handleMoveUp(page)}
                >
                  {t.move_up} <FontAwesomeIcon icon={faArrowUp} />
                </button>
                /
                <button
                  className={isAuthorized(ACL.INFORMATION_PAGE) ? "admin-order-move" : "admin-order-move-disabled"}
                  onClick={() => handleMoveDown(page)}
                >
                  {t.move_down} <FontAwesomeIcon icon={faArrowDown} />
                </button>
              </div>
              <div className="text-right">
                <button 
                  className="admin-edit-button"
                  disabled={!isAuthorized(ACL.INFORMATION_PAGE)}
                  onClick={() => handleEditInformationPage(page)}
                > 
                  {t.edit} <FontAwesomeIcon icon={faPenToSquare} />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {showOverlay && (
        <Overlay
          isOpen={showOverlay}
          onClose={closeOverlay}
          page={overlayPage}
          createNew={createNew}
          onRefresh={refreshPages}
        />
      )}
    </>
  );
};

export default InformationPages;